<template>
  <div class="">
    <div v-if="itemsData != null" class="data_device_map">
      <l-map :zoom="currentZoom" :center="currentCenter" class="style_map">
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker v-for="item in itemsData" :key="item._id" :lat-lng="[item.latitude, item.longitude]">
          <l-popup>
            <div class="ctn_map_market">
              <div class="ctn_market_col _icon">
                <img src="../../assets/img/electric-meter_1.svg" alt="" />
                <span> {{ item.idx }}</span>
              </div>
              <div class="ctn_market_col">
                <div class="copy">
                  <div class="">
                    <span v-if="item.profile == 'post'">Pospago</span>
                    <span v-else>Prepago</span>
                  </div>
                  <span><b>Tipo:</b> {{ item.subTypeService }}</span>
                  <span><b>NUI:</b> {{ item.nui }}</span>
                  <span><b>Dirección</b> {{ item.address }}</span>
                  <div class="">
                    <span class="device_active" v-if="item.switch == true">Prendido</span>
                    <span class="device_inactive" v-else>Apagado</span>
                  </div>
                </div>
              </div>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
    <!-- <SkeletonTable v-if="loadBar == true"></SkeletonTable> -->
    <!-- <v-card v-else class="no-shadow"> -->
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        Dispositivos
        <v-spacer></v-spacer>
        <v-combobox v-if="isMaster" class="input_filter" ref="company" v-model="company" :items="itemsDataCompany"
          :search-input.sync="searchCompany" item-value="_id" item-text="name" placeholder="filtrar empresa"
          clearable></v-combobox>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por NUI, código interno, serial."
          single-line hide-details></v-text-field>
      </v-card-title>
      <!-- {{ getLoadTable }} -->
      <v-data-table dense :headers="getHeader" :items="itemsData" :loading="cargando" :footer-props="{
        'items-per-page-options': [10, 20, 50, 100],
      }" :items-per-page="pagination.itemsPerPage" :server-items-length="totalNumberOfItems"
        :options.sync="pagination" :search="search" loading-text="Cargando información ..." hide-default-header>
        <template v-slot:[`header`]="{ props: { headers } }">
          <thead>
            <tr>
              <th v-for="item in headers" :key="item.value" class="column"
                v-bind:class="[item.sortable != false ? 'cursor-pointer' : '', columnOrder == item.value ? 'black--text' : '']"
                @click="item.sortable != false && changeSort(item.value)">
                <v-tooltip top :disabled="item.tooltip == undefined" color="primary">
                  <template v-slot:[`activator`]="{ on, attrs }">
                    <div class="d-flex" v-bind="attrs" v-on="on">
                      <v-icon v-if="item.sortable != false && columnOrder == item.value" class="mr-1" x-small>
                        {{ orderDesc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                      </v-icon>
                      <div>{{ item.text }}</div>
                    </div>
                  </template>
                  <span>{{ item.tooltip }}</span>
                </v-tooltip>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:[`item.activate`]="{ item }">
          <div class="lb lb_activo" v-if="item.activate == 1">Activo</div>
          <div class="lb lb_inactivo" v-else>
            <span class="span_inactive">Inactivo</span>
          </div>
        </template>
        <template v-slot:[`item.state`]="{ item }">
          <div v-if="item.state == true">
            <v-icon class="i-con on">mdi-checkbox-blank-circle</v-icon>
          </div>
          <div v-else>
            <v-icon class="i-con off">mdi-checkbox-blank-circle</v-icon>
          </div>
        </template>
        <template v-slot:[`item.switch`]="{ item }">
          <div v-if="item.switch == true" class="text-center">
            <v-icon class="i-con on">mdi-checkbox-blank-circle</v-icon>
            <span> </span>
          </div>
          <div v-else class="text-center">
            <v-icon class="i-con off">mdi-checkbox-blank-circle</v-icon>
            <span> </span>
          </div>
        </template>
        <template v-slot:[`item.lastData`]="{ item }">
          <div class="ctn_lasdata">
            <p v-if="item.lastData != null" class="ctn_lasdata_date">
              {{ item.lastData.createdAt | formatDateFrom }}
            </p>
            <p class="ctn_lasdata_item">
              <span v-if="item.lastData != null">
                {{ item.lastData.valUsage | threeDigit }}{{ item.lastData.unitValUsage }}</span>
              <span v-else class="none"> - </span>
            </p>
          </div>
        </template>
        <template v-slot:[`item.lastData.valNow`]="{ item }">
          <div class="ctn_lasdata">
            <p class="ctn_lasdata_item">
              <span class="grey_data">
                {{
                  item.lastData !== undefined
                  ? item.lastData.valNow + item.lastData.unitValNow
                  : "0 --" | calculateUsage(item.dataValue.val, item.dataValue.unitVal)
                }}</span>
            </p>
          </div>
        </template>
        <template v-slot:[`item.dataValue`]="{ item }">
          <div class="ctn_lasdata">
            <p class="ctn_lasdata_item">
              <span class="grey_data">{{ item.dataValue.val | twoDigit }}{{ item.dataValue.unitVal }}</span>
            </p>
          </div>
        </template>
        <template v-slot:[`item.profile`]="{ item }">
          <div v-if="item.profile == 'post'">Postpago</div>
          <div v-else>Prepago</div>
        </template>
        <template v-slot:[`item.updateAt`]="{ item }">
          {{ item.updateAt | formatDateFrom }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="table_menu" color="primary" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="list_action">
                <v-btn class="cent" @click="setClearDeviceQuery(null)" plain
                  :to="getRouteName(item.typeDevice, item._id)">VER</v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn plain @click="editItem(item)">
                  <span>Editar</span>
                </v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn class="cent" @click="takeItem(item)" plain>Lectura</v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn v-if="item.state == true" plain @click="connectItem(item)">
                  <span>Deshabilitar</span>
                </v-btn>
                <v-btn v-else plain @click="connectItem(item)">
                  <span>Habilitar</span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <Edit :data="itemObjct" :visible="EditFlag" @close="EditFlag = false"></Edit>
    <Connect :data="itemObjct" :visible="ConnectFlag" @close="ConnectFlag = false"></Connect>
    <TakeRead :data="itemObjct" :visible="TakeFlag" @close="TakeFlag = false"></TakeRead>
  </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { latLng, Icon } from "leaflet";
import axios from "axios";
import moment from "moment";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Edit from "@/components/device/Edit.vue";
import Connect from "@/components/device/Connect.vue";
import TakeRead from "@/components/device/TakeRead.vue";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

//import SkeletonTable from '@/components/SkeletonTable.vue'
export default {
  name: "DeviceTableComp",
  components: {
    LMap,
    LTileLayer,
    LPopup,
    LMarker,
    Edit,
    Connect,
    TakeRead,
    //SkeletonTable,
  },
  data() {
    return {
      search: "",
      flagTable: true,
      EditFlag: false,
      TakeFlag: false,
      ConnectFlag: false,
      itemsData: [],
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      columnOrder: "serial",
      orderDesc: false,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 20,
      },
      cargando: false,
      searchCompany: "",
      company: null,
      itemsDataCompany: [],
      totalNumberOfItemsComp: 0,
      paginationc: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      itemObjct: {},
      withPopup: latLng(4.68528905630448, -74.05240637359361),
      currentCenter: latLng(2.9258926973614527, -75.27372299172067),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showMap: true,
      currentZoom: 13,
      showParagraph: false,
      headerMaster: [
        { text: "Estado", value: "activate" },
        { text: "On/Off", value: "switch" },
        { text: "IDX", value: "idx" },
        { text: "Empresa", value: "company.name" },
        { text: "NUI", value: "nui", align: "start" },
        { text: "Cód.Interno", value: "alternateCode" },
        { text: "Ruta", value: "road.name" },
        { text: "Zona", value: "zone.name" },
        { text: "Ciclo", value: "cycle.name" },
        { text: "Tipo", value: "subTypeService" },
        { text: "Perfil", value: "profile" },
        { text: "Serial", value: "serial" },
        { text: "Dirección", value: "address" },
        {
          text: "C.Anterior",
          value: "lastData",
          sortable: false,
          width: "10%",
          tooltip: "Consumo del periodo anterior",
        },
        {
          text: "C.Actual",
          value: "lastData.valNow",
          tooltip: "Consumo del periodo actual",
        },
        {
          text: "L.Medidor",
          value: "dataValue",
          tooltip: "Lectura actual del medidor",
        },
        { text: "Actualizado", value: "updateAt" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      headersClient: [
        { text: "Estado", value: "activate" },
        { text: "On/Off", value: "switch", width: "1%", sortable: false },
        { text: "IDX", value: "idx" },
        { text: "Serial", value: "serial" },
        { text: "NUI", value: "nui", align: "start" },
        { text: "Cód.Interno", value: "alternateCode" },
        { text: "Ruta", value: "road.name" },
        { text: "Zona", value: "zone.name" },
        { text: "Ciclo", value: "cycle.name" },
        { text: "Dirección", value: "address" },
        {
          text: "C.Anterior",
          value: "lastData",
          sortable: false,
          tooltip: "Consumo del periodo anterior",
        },
        {
          text: "C.Actual",
          value: "lastData.valNow",
          tooltip: "Consumo del periodo actual",
        },
        {
          text: "L.Medidor",
          value: "dataValue",
          tooltip: "Lectura actual del medidor",
        },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  async mounted() {
    //await this.listCompany();
    this.getJsonData();
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    //await this.listDevice();
  },
  watch: {
    searchCompany: {
      handler() {
        this.getJsonCompany().then((data) => {
          this.itemsDataCompany = data.docs;
        });
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    columnOrder: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
          this.cargando = false;
        });
      },
      deep: true,
    },
    orderDesc: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
          this.cargando = false;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["listDevice", "listCompany"]),
    ...mapMutations(["setClearDeviceQuery"]),
    actionTableNull() {
      setTimeout(() => {
        return false;
      }, 2000);
    },
    changeSort(column) {
      if (this.columnOrder === column) {
        this.orderDesc = !this.orderDesc;
      } else {
        this.columnOrder = column;
        this.orderDesc = false;
      }
    },
    async getJsonCompany() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)

          axios
            .get(
              `company/list?page=${this.paginationc.page}&search=${this.searchCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsDataCompany = res.data.docs;
              this.totalNumberOfItemsComp = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          this.cargando = true;
          let headerToken = { token: this.$store.state.token };
          let queryPage = this.pagination.page ? 'page=' + this.pagination.page : 'page=1';
          let queryLimit = this.pagination.itemsPerPage ? '&limit=' + this.pagination.itemsPerPage : '';
          let queryColumn = this.columnOrder ? '&columnOrder=' + this.columnOrder : '';
          let queryOrder = this.orderDesc ? '&order=asc' : '&order=desc';
          let queryCompany = this.company ? '&company=' + this.company._id : '';
          let querySearch = this.search ? '&search=' + this.search : '';

          axios
            .get(
              `device/listcustom?${queryPage}${queryLimit}${querySearch}${queryCompany}${queryColumn}${queryOrder}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.cargando = false;
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              this.cargando = false;
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    takeItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.TakeFlag = true;
    },
    editItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.EditFlag = true;
    },
    connectItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.ConnectFlag = true;
    },
    getRouteName(subtypeDevice, id) {
    return {
    
      name: subtypeDevice === 'Lora-Wan' ? 'DeviceID_loRaWan' : 'DeviceID_loRa',
      params: { id: id }
    };
  },
  },
  computed: {
    ...mapGetters(["getListDevice", "isMaster"]),
    loadBar() {
      if (this.itemsData.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    getLoadTable() {
      if (this.itemsData.length > 0 || this.cargando == false) {
        return false;
      } else {
        return this.actionTableNull();
      }
    },
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster;
      }
      return this.headersClient;
    },
  },
  filters: {
    threeDigit(val) {
      if (val != null && val != undefined) {
        return `${val
          .toFixed(3)
          .toString()
          .replace(".", ",")}`;
      }
      return '0';
    },
    twoDigit(val) {
      if (val != null && val != undefined) {
        return `${val
          .toFixed(2)
          .toString()
          .replace(".", ",")}`;
      }
      return '0';
    },
    calculateUsage(lastRead, readNow, unit) {
      const readNowNumber = parseFloat(readNow);
      const lastReadNumber = parseFloat(lastRead);
      return (
        (readNowNumber - lastReadNumber)
          .toFixed(2)
          .toString()
          .replace(".", ",") + unit
      );
    },
    getTakeReadDate(array) {
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1);
        return filter[0].dateNow;
      }
      return "-";
    },
    getTakeRead(array) {
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1);
        return filter[0].usage;
      }
      return "-";
    },
    formatDateFrom: (value) => {
      if (value) {
        return moment(value).locale("es").fromNow();
      }
      return "-";
    },
    formatDateShort: (value) => {
      if (value) {
        return moment(value).locale("es").format("LL");
      }
      return "-";
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("LLL");
      }
      return "-";
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/base.scss";

.ctn_lasdata {
  p {
    margin: 0;

    &.ctn_lasdata_date {
      font-weight: 600;
      font-size: 0.7rem;
      margin-bottom: 0;
    }

    &.ctn_lasdata_item {
      span {
        border-radius: 4px;
        padding: 1px 5px;
        background-color: $dark-jungle-green;
        color: $light-cyan;

        &.grey_data {
          background-color: #dcdcdc;
          color: $blue-btn;
        }

        &.none {
          color: $color-text-grey;
          background-color: transparent;
        }
      }
    }
  }
}

.input_filter {
  position: relative;
  top: 16px;
  padding: 0 50px;
  width: 80px;
}

.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}

.span_inactive {
  color: $alert;
}

.list_action {
  padding: 0 2px;

  &:last-child {

    button:hover,
    a:hover {
      background-color: $alert;
    }
  }

  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;

    &.cent {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    width: 100%;

    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }

  span {
    font-size: 0.9rem;
  }
}

span.lbs {
  border-radius: 4px;
  font-size: 0.75rem;
  margin: 2px;

  &.sw_active {
    color: #fff;
    padding: 5px 10px;
    background-color: $bag-green;
  }

  &.sw_inactive {
    padding: 5px 10px;
    background-color: $alert;
    color: #fff;
  }
}

i.i-con {
  font-size: 0.8rem !important;

  &.off {
    color: $alert;
  }

  &.on {
    color: $green-btn;
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
